import { render, staticRenderFns } from "./AppTagList.vue?vue&type=template&id=a6a58bfc&lang=pug"
import script from "./AppTagList.vue?vue&type=script&lang=js"
export * from "./AppTagList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports